export const wireResistance = {
  copper: {
    "14 AWG": { resistance: 3.14, reactance: 0.05 },
    "12 AWG": { resistance: 1.98, reactance: 0.05 },
    "10 AWG": { resistance: 1.24, reactance: 0.05 },
    "8 AWG": { resistance: 0.778, reactance: 0.05 },
    "6 AWG": { resistance: 0.491, reactance: 0.05 },
    "4 AWG": { resistance: 0.308, reactance: 0.05 },
    "2 AWG": { resistance: 0.194, reactance: 0.05 },
    "1/0 AWG": { resistance: 0.122, reactance: 0.05 },
  },
  aluminum: {
    "12 AWG": { resistance: 3.14, reactance: 0.06 },
    "10 AWG": { resistance: 1.97, reactance: 0.06 },
    "8 AWG": { resistance: 1.24, reactance: 0.06 },
    "6 AWG": { resistance: 0.778, reactance: 0.06 },
    "4 AWG": { resistance: 0.491, reactance: 0.06 },
    "2 AWG": { resistance: 0.308, reactance: 0.06 },
    "1/0 AWG": { resistance: 0.194, reactance: 0.06 },
  },
};
